import { render } from "./PendingCasesView.vue?vue&type=template&id=19917eb4"
import script from "./PendingCasesView.vue?vue&type=script&lang=js"
export * from "./PendingCasesView.vue?vue&type=script&lang=js"

import "./PendingCasesView.vue?vue&type=style&index=0&id=19917eb4&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pendingCases/PendingCasesView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19917eb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19917eb4', __exports__)) {
    console.log('reload')
    api.reload('19917eb4', __exports__)
  }
  
  module.hot.accept("./PendingCasesView.vue?vue&type=template&id=19917eb4", () => {
    console.log('re-render')
    api.rerender('19917eb4', render)
  })

}


export default __exports__